import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CapacityFilterState {
  showPausedUnknown: boolean;
  toggle: () => void;
}

export const useCapacityFilterStore = create<CapacityFilterState>()(
  persist(
    (set) => ({
      showPausedUnknown: false,
      toggle: () => set((s) => ({ showPausedUnknown: !s.showPausedUnknown })),
    }),
    { name: 'fcp-capacity-filter' },
  ),
);
